.piece {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.kind {
  margin: 0;
  font-size: 1rem;
}

.identical {
  margin: 0;
  color: var(--text-muted);
}

.diff {
  margin: 0;
  padding: 0.5rem;
  overflow-x: auto;
  background: var(--surface-sunken);
  border: 1px solid var(--border);
  font-family: ui-monospace, monospace;
  font-size: 0.875rem;
}

.added {
  display: block;
  background: var(--success-surface);
  color: var(--success-text);
}

.removed {
  display: block;
  background: var(--danger-surface);
  color: var(--danger-text);
}

.header,
.hunk {
  display: block;
  color: var(--text-muted);
}

.hunk {
  font-weight: 600;
}
